import Vue from 'vue';
import 'vue-awesome/icons';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import Icon from 'vue-awesome/components/Icon';
import 'babel-polyfill';
import 'whatwg-fetch';
import 'bootstrap-loader';
import * as PrimeVue from 'primevue/config';
import VeeValidate from 'vee-validate';
import datePicker from 'vue-bootstrap-datetimepicker';
import money from 'v-money';
import fetchClientToken from '@/services/dwolla';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'; // eslint-disable-line import/no-extraneous-dependencies
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
import store from '@/store';
import App from './App';
import router from './router';
import { loggly as logglyConfig } from './config/config';
import CognitoAuth from './services/cognito';
import HttpService from './api/HttpService';
import constantToTitleCase from './util/filters';
import './theme/main.css';

window.fetchClientToken = fetchClientToken;

const VueInputMask = require('vue-inputmask').default;

Vue.config.productionTip = false;
Vue.component('icon', Icon);

// Make HttpService available as this.$http in components
Vue.prototype.$http = HttpService;

Vue.use(CognitoAuth);
Vue.use(datePicker);
Vue.use(VueInputMask);
Vue.use(VeeValidate);
Vue.use(money, { precision: 2 });
Vue.use(Tooltip);
Vue.use(PrimeVue);

Vue.filter('constantToTitleCase', constantToTitleCase);

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

const isAuthenticated = async () => Vue.prototype.$cognitoAuth.isAuthenticated();

async function isLoggedInUserAnAdmin() {
  if (await isAuthenticated()) {
    return (
      store.state.app.irAdmin ||
      HttpService.getV2('users/user').then((user) => {
        const { roles } = user;
        store.commit('app/SET_IR_ADMIN_ROLE', roles.includes('IR_ADMIN'));
        store.commit('app/SET_USER', user);
        return store.state.app.irAdmin;
      })
    );
  }
  store.commit('app/SET_IR_ADMIN_ROLE', false);
  return store.state.app.irAdmin;
}

function routeRequiresAdminRole(route) {
  return route.meta.requiresIrAdminRole || false;
}

async function isInvestorTryingToGetAdminRoute(route) {
  return routeRequiresAdminRole(route) && !(await isLoggedInUserAnAdmin());
}

async function isAdminTryingToGetInvestorRoute(route) {
  // eslint-disable-next-line no-return-await
  return !routeRequiresAdminRole(route) && await isLoggedInUserAnAdmin();
}

router.beforeResolve(async (to, from, next) => {
  const notProtectedRoutes = [
    'Login',
    'Registration',
    'ResetPassword',
    'ErrorAuth',
    'EmbedLogin',
    'VerifyEmail',
    'ChangePassword',
  ];
  if (await isInvestorTryingToGetAdminRoute(to)) {
    next('/home');
  } else if (await isAdminTryingToGetInvestorRoute(to)) {
    next('/users');
  } else if (
    !(await isAuthenticated()) &&
    !notProtectedRoutes.includes(to.name)
  ) {
    next('/login');
  } else {
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
});

const _LTracker = global._LTracker = global._LTracker || []; // eslint-disable-line
_LTracker.push({// eslint-disable-line
  logglyKey: logglyConfig.logglyKey,
  sendConsoleErrors: true,
});



// WEBPACK FOOTER //
// ./src/main.js